// File: stock-location.js
// Store stock locator - the "Click & Reserve" tab on product pages.
//
// 19 Aug 2026 change: the tab now hides itself whenever the stock feed is
// unavailable or returns nothing, instead of printing "Unable to load store
// stock right now." on a live product page. A small guard stylesheet hides the
// tab and its panel from first paint; it is removed only once the feed has
// actually returned at least one location row.
//
// To restore the previous always-visible behaviour: delete addGuard/removeGuard
// and the calls to them. Nothing else in the file has changed.

if (window.location.pathname.indexOf('/products/') !== -1) {
  // Runs immediately (script is deferred, so before first paint of the tab bar).
  addGuard();

  $(document).ready(function () {
    function loadinvetrytable() {
      var url = new URL(window.location.href);

      // 1. URL Query Param -> 2. Form Input -> 3. Shopify Native Global Metadata
      var varient_id = url.searchParams.get("variant")
                    || $('[name="id"]').val()
                    || $("form[action*='/cart/add'] [name='id']").val()
                    || $('select[name="id"]').val()
                    || $('input[name="id"]').val()
                    || (typeof ShopifyAnalytics !== 'undefined' && ShopifyAnalytics.meta && ShopifyAnalytics.meta.selectedVariantId ? ShopifyAnalytics.meta.selectedVariantId : '')
                    || (typeof ShopifyAnalytics !== 'undefined' && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.variants && ShopifyAnalytics.meta.product.variants[0] ? ShopifyAnalytics.meta.product.variants[0].id : '')
                    || (typeof meta !== 'undefined' && meta.product && meta.product.variants && meta.product.variants[0] ? meta.product.variants[0].id : '');

      var product_id = (typeof stocklocation_product_id !== 'undefined' ? stocklocation_product_id : '')
                    || (typeof ShopifyAnalytics !== 'undefined' && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product ? ShopifyAnalytics.meta.product.id : '')
                    || (typeof meta !== 'undefined' && meta.product ? meta.product.id : '');

      if (!varient_id) {
        console.warn("Stock Locator: Variant ID not found!");
        hideLocatorTab();
        return;
      }

      $.ajax({
        url: "https://shop.coderkubes.com/seasonCookShop/StockLocation/season_cookshop_locations.php",
        type: "post",
        dataType: "json",
        timeout: 8000,
        data: {
          productId: product_id,
          varientId: varient_id
        },
        success: function (response) {
          var loc_html = '<table><tbody>';
          var rows = 0;

          if (response && typeof response === 'object') {
            $.each(response, function (key, val) {
              if (!val || typeof val !== 'object') return true;
              if (!val.inventory_name) return true;

              loc_html += '<tr>';
              loc_html += '<td>' + val.inventory_name + '</td>';
              loc_html += '<td>' + val.stock_status + '</td>';

              var cfp_className = (val.islink == "yes") ? 'sb_cfp_cta' : '';
              loc_html += '<td><div class="' + cfp_className + '" data-locid="' + val.location_id + '">' + val.link_lbl + '</div></td>';
              loc_html += '</tr>';

              rows++;
            });
          }

          loc_html += '</tbody></table>';

          // Only reveal the tab if we actually have store data to show.
          if (rows > 0) {
            $(".tab-content-12346").html(loc_html);
            showLocatorTab();
          } else {
            console.log("Stock Locator: feed returned no locations - tab hidden.");
            hideLocatorTab();
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log("Stock Locator Error:", textStatus, errorThrown);
          hideLocatorTab();
        }
      });
    }

    // Initial Load on Page Ready
    loadinvetrytable();

    // Re-load when Variant is Changed by User
    $(document).on('change', 'form[action*="/cart/add"] [name="id"], select[name="id"], input[name="id"]', function () {
      setTimeout(function () {
        loadinvetrytable();
      }, 200);
    });
  });
}

// ---------------------------------------------------------------------------
// Tab visibility helpers
// ---------------------------------------------------------------------------

function addGuard() {
  if (document.getElementById('stock-locator-guard')) return;
  var guard = document.createElement('style');
  guard.id = 'stock-locator-guard';
  guard.textContent = 'li.custom-location-inentry, .tab-content-12346 { display: none !important; }';
  (document.head || document.documentElement).appendChild(guard);
}

function removeGuard() {
  var guard = document.getElementById('stock-locator-guard');
  if (guard && guard.parentNode) guard.parentNode.removeChild(guard);
}

function showLocatorTab() {
  removeGuard();
  $("ul.tabs>li.custom-location-inentry").show();
}

function hideLocatorTab() {
  addGuard();

  var $tab = $("li.custom-location-inentry");
  var $panel = $(".tab-content-12346");

  // If the customer had this tab open when it failed, fall back to the first tab
  // so they are never left looking at an empty panel.
  if ($tab.hasClass('current') || $panel.hasClass('current')) {
    $tab.removeClass('current');
    $panel.removeClass('current');
    $("li.tab-link-0").addClass('current');
    $(".tab-content-0").addClass('current');
  }

  $panel.empty();
}